export default __webpack_public_path__ + "static/media/img4.bf72406b.jpeg";